import { useCallback, useState } from 'react';
import { A05, A05Input, A05Output } from 'api/U002';

type CreateApplyFormRequest = A05Input;
type CreateApplyFormResponse = A05Output;

type CreateApplyFormDoRequest = (param: {
  request: CreateApplyFormRequest;
  onSuccess?: (response: CreateApplyFormResponse) => void;
  onError?: (err: Error) => void;
  cancellation?: AbortSignal;
}) => Promise<void>;

export function useCreateApplyForm(): [CreateApplyFormDoRequest, boolean, Error | null] {
  const [loading, setLoading] = useState<boolean>(false);
  const [err, setError] = useState<Error | null>(null);

  const createApplyForm = async (request: CreateApplyFormRequest, cancellation: AbortSignal) => {
    const json = await A05(request, cancellation);
    return json;
  };

  const doRequest = useCallback<CreateApplyFormDoRequest>(
    async ({ request, cancellation, onSuccess, onError }) => {
      const controller = new AbortController();
      const cancelSignal = cancellation ?? controller.signal;
      try {
        setLoading(true);
        setError(null);
        const applyForm = await createApplyForm(request, cancelSignal);
        onSuccess?.(applyForm);
      } catch (err) {
        console.error(err);
        const flooredError = err instanceof Error ? err : new Error(`unknown error. ${err}`);
        onError?.(flooredError);
        setError(flooredError);
      } finally {
        setLoading(false);
        controller.abort();
      }
    },
    [createApplyForm, setLoading, setError]
  );

  return [doRequest, loading, err];
}
